<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import {getCookie} from './assets/js/utils'

  export default {
  name: 'app',
  async created() {
    if (getCookie('Authorization')) {
      await this.GetCurrUserInfo()
    }
  },
  methods: {
    ...mapActions('user',['GetCurrUserInfo'])
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  min-width: 1200px;
}
html,body{
  margin: 0;
  width: 100%;
  height: 100%;
}
.flex-between{
  display: flex;
  justify-content: space-between;
}
.flex-end{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.align-center{
  display: flex;
  align-items: center;
}
:focus{
  outline: none;
}
.create-order-dialog.el-dialog{
  border-radius: 8px;
  .el-dialog__header{
    background-color: #F2F4F5;
    border-radius: 8px 8px 0 0;
    display: flex;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding: 0;
    color: #2E2E2E;
    font-size: 16px;
  }
  .el-dialog__footer{
    padding: 0 30px;
    height: 64px;
    display: flex;
    align-items: center;
    border-top: 1px solid #DFE0E0;
    justify-content: space-between;
  }
  .el-button{
    width: 98px;
  }
  .el-form-item__label{
    color: #000;
    font-weight: 500;
  }
}
.el-tooltip__popper {
  max-width: 200px;
}
.el-tooltip__popper.el-fade-in-linear-enter-active{-webkit-transition:opacity .2s linear 0.6s;transition:opacity .2s linear 0.6s}
</style>

<style>
  .ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .divider{
    width: 100%;
    height: 1px;
    background-color: #EBEEF5;
  }
  .el-form-item__label{
    text-align: left!important;
  }
  .tag{
    line-height: 22px;
    border-radius: 4px;
    padding: 0 7px;
    font-size: 12px;
  }
  .tips{
    width: 100%;
    display: flex;
    border: 1px solid #91D5FF;
    font-size: 14px;
    align-items: center;
    padding: 0 25px;
    border-radius: 2px;
    height: 65px;
    box-sizing: border-box;
    background-color: #E9F3FF;
  }
  .tips>i{
    margin-right: 17px;
    font-weight: 600;
    margin-bottom:20px;
  }
  .tips>p{
    flex: 1;
  }
  *{
    margin: 0;
    padding: 0;
  }
  textarea {
    resize: none!important;
  }

  .el-dialog__body{
    padding-top: 6px!important;
  }
  .el-table th{
    padding: 9px 0!important;
  }
  .el-table td{
    padding: 6px 0!important;
  }
  .el-button--text{
    padding-top: 0!important;
    padding-bottom: 0!important;
  }

  .el-message-box__message{
    word-break: break-all;
  }
</style>
